import React, { useEffect, useState, useContext } from "react";
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
  Container,
  duration,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useNotify, validateToken } from "./Utils";
import { UserDataContext } from "./Context";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import {IconButton} from "@mui/material";
import DisplayLogo from "./LogoDisplay";




const AccountSettings = () => {
  const [userData] = useContext(UserDataContext);
  const navigate = useNavigate();
  const notify = useNotify();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
  });

  const [editField, setEditField] = useState(null);
  const [tempValue, setTempValue] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [errors, setErrors] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getUserInfo = () => {
      validateToken({ userData }).then((token) => {
        fetch(`${process.env.REACT_APP_API_URL}/getuserinfo`, {
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((resp) => resp.json())
          .then((data) => setFormData(data))
          .catch((error) => console.log(error));
      });
    };

    getUserInfo();
  }, [userData]);

  const validateFields = () => {
    let newErrors = {};
    let isValid = true;

    if (!tempValue.trim()) {
      newErrors[editField] = "This field is required.";
      isValid = false;
    }

    if (editField === "email" && !/\S+@\S+\.\S+/.test(tempValue)) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleOpenDialog = (field) => {
    setEditField(field);
    setTempValue(formData[field]);
    setErrors({});
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setEditField(null);
    setTempValue("");
    setErrors({});
    setOpenDialog(false);
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    
    try {
      setLoading(true)
      const token = await validateToken({ userData });
      if (editField === "email") {
        const fetching = await fetch(`${process.env.REACT_APP_API_URL}/changeuseremail`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ email: tempValue }),
      })
        const resp = await fetching.json()
        if (fetching.ok) {
          notify({message: resp, variant: "success"});
          handleCloseDialog();
          return
        }
        else {
          notify({
            message: resp,
            variant: "warning"
          })
          // handleCloseDialog();
          return
        }
        
      } 
      else if (editField === "username") {
        const fetching = await fetch(`${process.env.REACT_APP_API_URL}/changeusername`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username: tempValue }),
      })
          const resp = await fetching.json()
          if (fetching.ok) {
            notify({
              message: resp,
              variant: "success",
              duration:1000
            });
            handleCloseDialog();
            return
          }
          else {
            notify({
              message: resp,
              variant: "warning"
            });
            handleCloseDialog();
            return
          }
          
        }
    }
    catch (error) {
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})
      console.log(error)
      return;
     }
     finally {
      setLoading(false)
     }
    
  };

  const handleOpenDeleteDialog = () => setDeleteDialogOpen(true);
  const handleCloseDeleteDialog = () => setDeleteDialogOpen(false);
  const handleDeleteAccount = async() => {
    try {
      setLoading(true)
      const token = await validateToken({ userData });
      const fetchDeletion = await fetch(`${process.env.REACT_APP_API_URL}/deleteaccount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    const resp = await fetchDeletion.json()
    if (fetchDeletion.ok) {
      
      notify({
        message: resp,
        variant: "success",
        
      })

    }
    else {
      notify({
        message: resp,
        variant: "warning"
      })
    }
    }
    catch (error)  {
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})
      console.log(error)
    }
    finally {
      setLoading(false)
    }
    setDeleteDialogOpen(false);
    navigate("/");
  };


  if (!userData.userIsLogin) {
    navigate("/");
    return null;
  }

  return (
    
    <Container sx={{ mt: 10}}>
      <Box  sx={{display: "flex", justifyContent: "center",my:3}}>
        <DisplayLogo width={{xs: 80,md: 100}} height={{xs: 80,md: 100}} />
      </Box>
    
    <Card>
    <CardContent>
      <Typography
        variant="h6"
        sx={{ textAlign: "center", mb: 2, fontSize: { xs: "1rem", sm: "1.2rem" } }}
      >
        Account Settings
      </Typography>

      <Box sx={{ overflowX: "auto" }}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              {["username", "email"].map((field) => (
                <TableRow key={field}>
                  <TableCell
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "row", sm: "row" },
                      alignItems: { sm: "center" },
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography fontWeight={600}>
                        {field.charAt(0).toUpperCase() + field.slice(1)}:
                      </Typography>
                      <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                        {formData[field]}
                      </Typography>
                    </Box>
                    <Box mt={{ xs: 1, sm: 0 }}>
                      <IconButton
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpenDialog(field)}
                      >
                        <ModeEditOutlineOutlinedIcon/>
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box mt={3} textAlign="center">
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={handleOpenDeleteDialog}
        >
          Delete Account
        </Button>
      </Box>
    </CardContent>

    {/* Edit Dialog */}
    <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="xs">
      <DialogTitle>
        {editField ? `Change ${editField.charAt(0).toUpperCase() + editField.slice(1)}` : "Change Field"}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label={editField ? editField.charAt(0).toUpperCase() + editField.slice(1) : "Field"}
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          error={!!errors[editField]}
          helperText={errors[editField]}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleCloseDialog}>Cancel</Button>
        <Button loading={loading} variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>

    {/* Delete Dialog */}
    <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
      <DialogTitle>Confirm Account Deletion</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete your account? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleCloseDeleteDialog}>Cancel</Button>
        <Button  loading={loading} variant="contained" color="error" onClick={handleDeleteAccount}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  </Card>
</Container>

  );
};

export default AccountSettings;
